import React from "react";
import Private from "./Private";
import ErrorBoundary from "../../components/ErrorFallback";
import Dashboard from "../../pages/Dashboard";
import Board from "../../pages/Board";
import BoardPage from "../../pages/BoardPage";
import MyTask from "../../pages/MyTask";
import Feeds from "../../pages/Feeds";
import FeedCardDetail from "../../pages/FeedCardDetail";
import Watching from "../../pages/Watching";
import AdminBoards from "../../pages/AdminBoards";
import Workflow from "../../pages/Workflow";
import AdminUsers from "../../pages/AdminUsers";
import Report from "../../pages/Report";
import SystemSettingComp from "../../pages/SystemSettingComp";
import BoardUrlController from "../controllers/BoardUrlController";
import LoginAsSuperAdmin from "../../components/LoginAsSuperAdmin";
import { createRoute, wrapRouteElement } from "../utils/routeUtils";

const withErrorBoundary = (element) => wrapRouteElement(element, [ErrorBoundary]);

const adminRoutes = [
  createRoute({
    path: "/admin-board",
    element: <AdminBoards />,
    wrappers: [ErrorBoundary],
  }),
  createRoute({
    path: "/admin-workflow",
    element: <Workflow />,
    wrappers: [ErrorBoundary],
  }),
  createRoute({
    path: "/admin-user",
    element: <AdminUsers />,
    wrappers: [ErrorBoundary],
  }),
  createRoute({
    path: "/admin-report",
    element: <Report />,
    wrappers: [ErrorBoundary],
  }),
  createRoute({
    path: "/system-setting",
    element: <SystemSettingComp />,
    wrappers: [ErrorBoundary],
  }),
];

export const Pages = {
  element: (
    <LoginAsSuperAdmin>
      <Private />
    </LoginAsSuperAdmin>
  ),
  children: [
    {
      element: withErrorBoundary(<Dashboard />),
      children: [
        createRoute({
          path: "/board",
          element: <Board />,
          wrappers: [ErrorBoundary],
        }),
        createRoute({
          path: "/board/:id",
          element: <BoardPage />,
          wrappers: [ErrorBoundary, BoardUrlController],
          children: [
            {
              path: ":cardId",
              element: null,
            },
          ],
        }),
        createRoute({
          path: "/my-task",
          element: <MyTask />,
          wrappers: [ErrorBoundary],
        }),
        createRoute({
          path: "/feeds/:id",
          element: <Feeds />,
          wrappers: [ErrorBoundary],
        }),
        createRoute({
          path: "/feeds/:id/:cardId",
          element: <FeedCardDetail />,
          wrappers: [ErrorBoundary],
        }),
        createRoute({
          path: "/watching",
          element: <Watching />,
          wrappers: [ErrorBoundary],
        }),
        ...adminRoutes,
      ],
    },
  ],
};
